import { Link } from "react-router-dom";
import { MapPin, Phone, MessageSquare, Mail } from "lucide-react";
import {
  BOOKING_URL,
  WHATSAPP_URL,
  PHONE_DISPLAY,
  PHONE_TEL,
  EMAIL_DISPLAY,
  ADDRESS_LINE,
  NAV_LINKS,
} from "../data/content";

export const Footer = () => {
  return (
    <footer className="bg-[#050505] border-t border-white/10 pt-16 pb-8 px-4 sm:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-white/10">
        <div>
          <Link to="/" className="flex items-center gap-3 text-white mb-4 group">
            <img src="/logo192.png" alt="Hammam Men's Spa" className="w-10 h-10 object-contain rounded-full border border-amber-400/50 shadow-md group-hover:scale-105 transition-transform" />
            <span className="font-serif text-xl font-black tracking-tight">
              Hammam <span className="text-amber-400">Men's Spa</span>
            </span>
          </Link>
          <p className="text-white/60 text-xs sm:text-sm leading-relaxed mb-6">
            New Delhi's premier male grooming & rejuvenation sanctuary.
            Experience ancient bathing rituals, deep therapy massage, and
            complete luxury.
          </p>
          <div className="flex gap-3">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-emerald-600/20 text-emerald-400 border border-emerald-500/40 p-2.5 rounded-full hover:bg-emerald-600 hover:text-white transition-all"
              aria-label="WhatsApp"
            >
              <MessageSquare className="w-4 h-4" />
            </a>
            <a
              href={PHONE_TEL}
              className="bg-amber-500/20 text-amber-400 border border-amber-500/40 p-2.5 rounded-full hover:bg-amber-500 hover:text-black transition-all"
              aria-label="Call Us"
            >
              <Phone className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-amber-400 font-bold mb-4">
            Quick Navigation
          </h4>
          <ul className="space-y-2.5 text-xs sm:text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <Link
                  to={l.href}
                  className="text-white/60 hover:text-amber-400 transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-amber-400 font-bold mb-4">
            Delhi Location
          </h4>
          <div className="space-y-3 text-xs sm:text-sm text-white/70">
            <div className="flex gap-2 items-start">
              <MapPin className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" />
              <span>{ADDRESS_LINE}</span>
            </div>
            <div className="flex gap-2 items-center">
              <Phone className="w-4 h-4 text-amber-400 shrink-0" />
              <a href={PHONE_TEL} className="hover:text-amber-400">
                {PHONE_DISPLAY}
              </a>
            </div>
            <div className="flex gap-2 items-center">
              <Mail className="w-4 h-4 text-amber-400 shrink-0" />
              <a href={`mailto:${EMAIL_DISPLAY}`} className="hover:text-amber-400">
                {EMAIL_DISPLAY}
              </a>
            </div>
            <p className="text-amber-300 font-medium pt-1">
              Open 7 Days • 10:00 AM to 11:00 PM
            </p>
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-amber-400 font-bold mb-4">
            VIP Booking
          </h4>
          <p className="text-xs text-white/60 mb-4">
            Book your slot now for instant confirmation or doorstep delivery.
          </p>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-center bg-gradient-to-r from-amber-300 to-amber-600 text-black px-6 py-3 rounded-xl text-xs font-bold uppercase tracking-[0.15em] hover:shadow-[0_0_15px_rgba(245,158,11,0.4)] transition-all"
          >
            Reserve Session
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto pt-6 flex flex-col sm:flex-row justify-between items-center text-[11px] text-white/40 gap-4">
        <div>© {new Date().getFullYear()} Hammam Men's Spa, New Delhi. All Rights Reserved.</div>
        <div>Designed for Discretion, Privacy & Rejuvenation.</div>
      </div>
    </footer>
  );
};
